module.exports = __webpack_public_path__ + "img/button-home5.161db733.png";